export function parseKioskBody(values) {
  return {
    background_color: values?.background_color || '',
    primary_color: values?.primary_color || '',
    secondary_color: values?.secondary_color || '',
    background_label_color: values?.background_label_color || '',
    background_url: values?.background_url || '',
    background_type: values.background_url && values.background_url.length > 0 ? 'image' : 'solid',
    bottom_section_header: values?.bottom_section_header || '',
    button_text: values?.button_text || '',
    appointments_button_text: values?.appointments_button_text || '',
    complete_subtitle: values?.complete_subtitle || '',
    complete_title: values?.complete_title || '',
    daily_contact_goal: values?.daily_contact_goal || '',
    double_opt_in: values?.double_opt_in || '',
    form_title: values?.form_title || '',
    intro_title: values?.intro_title || '',
    logo_url: values?.logo_url || '',
    opt_in_help: values?.opt_in_help || '',
    opt_in_legal: values?.opt_in_legal || '',
    opt_in_message: values?.opt_in_message || '',
    opt_in_title: values?.opt_in_title || '',
    round_logo: values?.round_logo || '',
    show_address: values?.show_address || false,
    show_anniversary: values?.show_anniversary || false,
    show_birthday: values?.show_birthday || false,
    show_email: values?.show_email || false,
    email_required: values?.email_required || false,
    top_section_header: values?.top_section_header || '',
    redirect_url: values?.redirect_url || '',
  };
}
